import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=70a457a2&"
import script from "./Card.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Card.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports